import React, { Component } from "react";
import { Row, Col, Spin, Input, notification, DatePicker, Modal, Button } from "antd";
import { Form } from '@ant-design/compatible';
// import TextBox from "../widget/TextBox";
// import DatePicker from '../widget/DatePicker/DatePicker'
import "./searchMember.css";
import MemberTable from "./memberTable";
import search from "../images/Search.svg";
import clear from "../images/clear.svg";
import blackscreen from "../images/emptysearchscreen.svg";
import nodata from "../images/NoData.svg";
import { InfoCircleTwoTone } from '@ant-design/icons';
import Config from "../../config";
import moment from "moment";
import dayjs from 'dayjs';
import WelcomePopup from "../EligibilityCheck/Welcomepopup";

class searchMemberCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {},
      search: {},
      headers: [],
      cardstate: true,
      currState: false,
      Geticon: false,
      clicked: false,
      noticeModal: false,
      //  sessionStorage.getItem("NoticeModal") === "true" &&
      //  sessionStorage.getItem("planName") === "solis",
      loader: false,
      Dummytable: [],
      sortedData: [],
      SearchParameter: {},
      sort: {
        column: null,
        direction: "asc",
      },
      messageForSubscriber:"",
      authorizationModal: false,
      complianceModal: false
    };
  }

  // Searching Member based on search result.
  SearchEpisode = (event) => {
    event.preventDefault();
    // console.log("hello iside form");
    this.props.form.validateFields(async (err, values) => {
      values.subscriberid =
        values.subscriberid == "" ? null : values.subscriberid;
      values.firstname = values.firstname == "" ? null : values.firstname;
      values.lastname = values.lastname == "" ? null : values.lastname;
      values.mbi = values.mbi == "" ? null : values.mbi;
      // values.medicare = values.medicare == "" ? null : values.medicare;
      values.phone = values.phone == "" ? null : values.phone;
      values.DateOfBirth = values.DateOfBirth
        ? dayjs(values.DateOfBirth).format("MM/DD/YYYY")
        : "";
      // Get values from sessionStorage
      const roleName = sessionStorage.getItem("rolename");
      const planName = sessionStorage.getItem("planName"); 

      // If Plan is NOT solis → always null
      if (planName !== "solis") {
        values.PcpNpi = null;
      }
      else {
        // existing logic (UNCHANGED)
        if (roleName && roleName.includes("Provider")) {
          const providerNpi = JSON.parse(sessionStorage.getItem("npivalue") || "[]");
          values.PcpNpi = providerNpi.length ? providerNpi.join(",") : null;
        }
        else {
          const taxidNpiMapping = JSON.parse(sessionStorage.getItem("taxidNpiMapping")) || [];

          const npis = taxidNpiMapping
            .flatMap(item => item.NPI || [])
            .filter(npi => npi);

          values.PcpNpi = npis.length ? npis.join(",") : null;
        }
      }
      if (
        values.subscriberid == null &&
        values.firstname == null &&
        values.lastname == null &&
        values.mbi == null &&
        // values.medicare == null &&
        values.phone == null &&
        values.DateOfBirth == null
      ) {
        this.openNotification();
      } else {
        this.setState({
          loader: true,
          Dummytable: "",
        });
        if (!err) {
          // this.state.SearchParameter = values;
          let data = await fetch(Config.api + "/SearchMemberBySubscriberIDs", {
            method: "POST",
            headers: {
              Authorization: sessionStorage.getItem("access_token"),
              Accept: "application/json",
              "Content-type": "application/json",
            },
            body: JSON.stringify({
              SearchParameter: values,
              PlanName: sessionStorage.getItem("planName"),
              IsDSNP: sessionStorage.getItem("IsDSNP")
            }),
            // body: JSON.stringify(values),
          });
          data = await data.json();
          this.setState({
            clicked: true,
            Dummytable: data.MemberDetails,
            messageForSubscriber : data.Message,
          });
          if (data.MemberDetails.length > 0) {
            this.setState({
              headers: Object.keys(data.MemberDetails[0]).map((key) => {
                return {
                  title: key,
                  displayName: Config.membertable[key]?.displayName,
                  display:
                    Config.membertable &&
                    Config.membertable[key] &&
                    Config.membertable[key].display
                      ? true
                      : false,
                  filterType: Config.membertable[key]?.filterType || "text",
                };
              }),
              Dummytable: data.MemberDetails,
              loader: false,
            });
          } else {
            this.setState({
              loader: false,
            });
          }
        }
      }
    });
  };

  // sorting table data for each column................
  tableSortresult = (column) => {
    const direction = this.state.sort.direction === "desc" ? "asc" : "desc";
    const sortedData = this.state.Dummytable.sort((a, b) => {
      if (
        column === "SubscriberID" ||
        column === "FirstName" ||
        column === "LastName" ||
        column === "MBI" ||
        column === "Gender" ||
        column === "DateOfBirth" ||
        column === "PCPName" ||
        column === "EffectiveDate" ||
        column === "TerminationDate"
      ) {
        const nameA =
          column === "SubscriberID"
            ? a.SubscriberID.toUpperCase()
            : column === "FirstName"
            ? a.FirstName === null
              ? ""
              : a.FirstName.toUpperCase()
            : column === "LastName"
            ? a.LastName === null
              ? ""
              : a.LastName.toUpperCase()
            : column === "MBI"
            ? a.MBI === null
              ? ""
              : a.MBI.toUpperCase()
            : column === "Gender"
            ? a.Gender === null
              ? ""
              : a.Gender.toUpperCase()
            : column === "DateOfBirth"
            ? a.DateOfBirth === null
              ? ""
              : a.DateOfBirth
            : column === "PCPName"
            ? a.PCPName === null
              ? ""
              : a.PCPName.toUpperCase()
            : column === "EffectiveDate"
            ? a.EffectiveDate === null
              ? ""
              : a.EffectiveDate
            : a.TerminationDate === null
            ? ""
            : a.TerminationDate;
        const nameB =
          column === "SubscriberID"
            ? b.SubscriberID.toUpperCase()
            : column === "FirstName"
            ? b.FirstName === null
              ? ""
              : b.FirstName.toUpperCase()
            : column === "LastName"
            ? b.LastName === null
              ? ""
              : b.LastName.toUpperCase()
            : column === "MBI"
            ? b.MBI === null
              ? ""
              : b.MBI.toUpperCase()
            : column === "Gender"
            ? b.Gender === null
              ? ""
              : b.Gender.toUpperCase()
            : column === "DateOfBirth"
            ? b.DateOfBirth === null
              ? ""
              : b.DateOfBirth
            : column === "PCPName"
            ? b.PCPName === null
              ? ""
              : b.PCPName.toUpperCase()
            : column === "EffectiveDate"
            ? b.EffectiveDate === null
              ? ""
              : b.EffectiveDate
            : b.TerminationDate === null
            ? ""
            : b.TerminationDate;

        if (nameA < nameB) {
          return -1;
        } else if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      } else {
        return a.column - b.column;
      }
    });

    if (direction === "asc") {
      sortedData.reverse();
    }

    this.setState({
      Dummytable: sortedData,
      sort: {
        column,
        direction,
      },
    });
  };

  ClearTextFiled = () => {
    this.props.form.resetFields();
    this.setState({
      Dummytable: "",
      Geticon: false,
      clicked: false,
      loader: false,
    });
  };

  getValue = () => {
    this.setState({
      Geticon: true,
    });
  };

  openNotification = () => {
    notification.open({
      message: "Notification Title",
      description: "Please Inter atleast one parameter !",
      onClick: () => {
        // console.log('Notification Clicked!');
      },
    });
  };
  handleCancel = () => {
    sessionStorage.setItem("NoticeModal", "false");
    sessionStorage.setItem("authorizationModal", "false"); 
    this.setState({
      noticeModal: false,
    });
  };

  handleComplianceCancel = () => {
    sessionStorage.setItem("ComplianceModal", "false");
    
    this.setState({
      complianceModal: false,
    });
  };

  handleCancelAut = () => {
    sessionStorage.setItem("authorizationModal", "false");
  
    this.setState({
      authorizationModal: false,
    });
  };

  render() {
    console.log("complianceModal",this.state.complianceModal)
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="" style={{ position: "fixed", width: "96vw" }}>
        {sessionStorage.getItem("planName") === "ultimate" && (
          <WelcomePopup />
        )}
        {this.state.currState != this.state.cardstate && (
          <div className="mr-2 pb-2 search-card">
            {/* Form for searching table data */}
            <Form onSubmit={this.SearchEpisode}>
              <Row className="pl-2 pt-2 pb-3">
                <Col className="search-card-text">Enter Details to search</Col>
              </Row>
              {sessionStorage.getItem("IsDSNP") === "0" && (
    <Row className="pl-2 pb-2">
      <Col span={24}>
        <div
          className="providerSearchBar"
          style={{ fontWeight: "bold" }}
        >
          <span>
            <span style={{ fontSize: "1.0em" }}>
              <InfoCircleTwoTone />
            </span>{" "}
            <span style={{ color: "#0080FF" }}>
              This is a filtered list as the user is not authorized to see DSNP Records.
            </span>
            <span style={{ color: "red" }}>**</span>
          </span>
        </div>
      </Col>
    </Row>
  )}
              <Row className="pl-2">
                <Col span={4}>
                  <Form.Item>
                    {getFieldDecorator("subscriberid", {
                      initialValue: null,
                      // rules: [
                      //   {
                      //     pattern: new RegExp("^[a-zA-Z' ']*$"),
                      //     message: "Enter Alphabets Only!"
                      //   }
                      // ],
                    })(
                      <Input
                        size="medium"
                        placeholder="Enter Subscriber ID"
                        onChange={this.getValue}
                      />
                    )}
                  </Form.Item>
                </Col>

                <Col span={5} className="pl-2">
                  <Form.Item>
                    {getFieldDecorator("firstname", {
                      initialValue: null,
                    })(
                      <Input
                        size="medium"
                        placeholder="Enter First Name"
                        onChange={this.getValue}
                      />
                    )}
                  </Form.Item>
                </Col>

                <Col span={5} className="pl-2">
                  <Form.Item>
                    {getFieldDecorator("lastname", {
                      initialValue: null,
                    })(
                      <Input
                        size="medium"
                        placeholder="Enter Last Name"
                        onChange={this.getValue}
                      />
                    )}
                  </Form.Item>
                </Col>

                <Col span={5} className="pl-2">
                  <Form.Item>
                    {getFieldDecorator("mbi", {
                      initialValue: null,
                    })(
                      <Input
                        size="medium"
                        placeholder="Enter MBI"
                        onChange={this.getValue}
                      />
                    )}
                  </Form.Item>
                </Col>

                {/* <Col span={4}>
                  <Form.Item>
                    {getFieldDecorator("medicare", {
                      initialValue: null,
                    })(
                      <Input
                        size="medium"
                        placeholder="Enter Medicare"
                        onChange={this.getValue}
                      />
                    )}
                  </Form.Item>
                </Col> */}

                <Col span={4} className="mb-2 pb-1 pl-2 pt-1">
                  <Form.Item>
                    {getFieldDecorator("DateOfBirth", {
                      initialValue: null,
                    })(
                      <DatePicker
                        size="medium"
                        placeholder="Select D.O.B."
                        format={["MM/DD/YYYY", "MM-DD-YYYY", "MMDDYYYY"]}
                        style={{ width: "234px" }}
                        onChange={this.getValue}
                      />
                    )}
                  </Form.Item>
                </Col>

                <Col span={0} className="pl-2" hidden>
                  <Form.Item>
                    {getFieldDecorator("phone", {
                      initialValue: null,
                    })(
                      <Input
                        size="medium"
                        placeholder="Enter Contact No."
                        onChange={this.getValue}
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>

              {/* Form Button Search and clear Both */}

              <div>
                {this.state.Dummytable.length > 0 && (
                  <div
                    style={{ marginLeft: "-90vw", marginTop: "22px" }}
                    className="pt-3 total-lenth"
                  >
                    <span>
                      {this.state.Dummytable.length + " "}
                      {this.state.Dummytable.length <= 1
                        ? "Member found"
                        : "Members found"}{" "}
                    </span>
                  </div>
                )}
                {this.state.Geticon == true && (
                  <div
                    style={{ float: "right", marginRight: "1vw" }}
                    className="pt-3"
                  >
                    <button
                      className="ml-3 mb-2 search-button search-button-color"
                      htmlType="submit"
                    >
                      <img src={search} style={{ marginTop: "-2px" }} />
                    </button>
                    {/* Clear form field Button */}
                    <button
                      className="ml-1 search-button clear-button-color"
                      onClick={this.ClearTextFiled}
                    >
                      <img src={clear} style={{ marginTop: "-2px" }} />
                    </button>
                  </div>
                )}
              </div>
            </Form>
          </div>
        )}

        {/* loader */}

        {this.state.loader == true ? (
          <div style={{ marginTop: "36vh", marginLeft: "46vw" }}>
            <Spin size="large" />
            <div style={{ marginLeft: "-6vw" }} className="search-sreen-text">
              Loading Table data...
            </div>
          </div>
        ) : (
          <div>
            <div className="pt-2">
              {this.state.headers && this.state.Dummytable.length > 0 && (
                <MemberTable
                  tableData={this.state.Dummytable}
                  headers={this.state.headers}
                  tableSort={this.tableSortresult}
                />
              )}

              {this.state.Dummytable.length > 0 && (
                <div
                  style={{ marginLeft: "-79vw", marginTop: "22px" }}
                  className="pt-3 total-lenth"
                >
                  <span>
                    {this.state.Dummytable.length + " "}
                    {this.state.Dummytable.length <= 1
                      ? "Member found"
                      : "Members found"}{" "}
                  </span>
                </div>
              )}
                <div className="no-data-found">
                  {this.state.Dummytable.length === 0 &&
                    this.state.clicked === true && (
                      <div>
                        <img src={nodata} />

                        <div className="npdata-text ml-4">
                           {this.state.messageForSubscriber ? (
                              this.state.messageForSubscriber
                            ) : (
                                <>
                                  Please check the parameters again <br />
                                  <span className="or">or</span> <br />
                                  Search with different parameters
                                </>
                              )}
                        </div>
                      </div>
                    )}
                </div>

            </div>
            <div className="blank-screen-image">
              {this.state.Dummytable == "" && this.state.clicked == false > 0 && (
                <div>
                  <img src={blackscreen} />
                  <div className="search-sreen-text ml-5">
                    Enter Details and search to see the Results
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
         <Modal
          title="2026 Provider Survey"
          open={this.state.noticeModal}
          onOk={this.handleCancel}
          onCancel={this.handleCancel}
          footer={null}
          closable={true} // Hide the close icon
          maskClosable={false} // Prevent closing by clicking outside
        >
          <p>Action Required: Please complete the 2026 Provider Survey. Check your email for the SurveyMonkey link to get started.</p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              key="cancel"
              type="default"
              onClick={this.handleCancel}
              style={{
                width: "70%",
                backgroundColor: "#ff6b6b",
                color: "white",
                border: "none",
                marginBottom: 16,
              }}
            >
              Ok
            </Button>
          </div>
        </Modal>


        <Modal
          title="Important Notice – Solis Health Plans Provider Portal"
          open={this.state.complianceModal}
          onOk={this.handleComplianceCancel}
          onCancel={this.handleComplianceCancel}
          footer={null}
          closable={true}
          maskClosable={false}
          width={1100}
        >
          <div
            style={{
              maxHeight: "500px",
              overflowY: "auto",
              paddingRight: "10px",
            }}
          >
            <p>Dear Provider,</p>

            <p>
              We are writing to let you know about a technical issue with the Solis
              Health Plans provider portal. Between <strong>September 1, 2026</strong>{" "}
              and <strong>September 26, 2026</strong>, the prior authorization list in
              the portal may have displayed requests for Solis members who are not your
              patients, along with your own. The issue has been corrected, and the
              portal now shows only prior authorization requests submitted for your
              patients.
            </p>

            <p>
              As a HIPAA covered entity, and under your participating provider
              agreement with Solis, your practice is required to protect member
              information. If you or your staff saw information about a Solis member
              who is not your patient, we ask that you:
            </p>

            <ul>
              <li>
                <strong>Do not use or share</strong> that information for any purpose.
              </li>
              <li>
                <strong>Do not keep it.</strong> Please delete or securely destroy any
                notes, printouts or screenshots that include it.
              </li>
              <li>
                <strong>Let us know right away</strong> if you believe the information
                was used or shared.
              </li>
            </ul>

            <p>
              No reply is needed unless one of the above applies. Please share this
              notice with any staff members who use the portal.
            </p>

            <p>
              Thank you for your partnership and for your care of our members. If you
              have questions, please contact{" "}
              <a href="mailto:compliance@solishealthplans.com">
                compliance@solishealthplans.com
              </a>
              .
            </p>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 20,
            }}
          >
            {/* <Button
              key="cancel"
              type="default"
              onClick={this.handleComplianceCancel}
              style={{
                width: "70%",
                backgroundColor: "#ff6b6b",
                color: "white",
                border: "none",
                marginBottom: 16,
              }}
            >
              OK
            </Button> */}
          </div>
        </Modal>

        <Modal
          title="Authorization Status"
          open={this.state.authorizationModal}
          onOk={this.handleCancelAut}
          onCancel={this.handleCancelAut}
          footer={null}
          closable={true}
          maskClosable={false}
        >
          <p>
            {sessionStorage.getItem("planName") === "solis" &&
              "Authorization status is temporarily unavailable, please check back in 48 hours. New authorizations can be submitted via Calypso Lyte."}

            {sessionStorage.getItem("planName") === "ultimate" &&
              "Authorization status is temporarily unavailable, please contact Provider Relations with any issues."}
          </p>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              type="default"
              onClick= {this.handleCancelAut}
              style={{
                width: "70%",
                backgroundColor: "#ff6b6b",
                color: "white",
                border: "none",
                marginBottom: 16,
              }}
            >
              Ok
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}

export default Form.create({ name: "searchMember" })(searchMemberCard);
